import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromProduct from '../_reducers/product';

export const selectProductState = createFeatureSelector<fromProduct.ProductState>('products');

export const selectAllProducts = createSelector(selectProductState, fromProduct.selectAll);

export const selectAllProductsWithStatus = createSelector(
  selectProductState,
  selectAllProducts,
  (state, products) => ({
    products,
    loading: state.loading,
    loaded: state.loaded,
    error: state.error,
  })
);
